import type { HelpTopic } from '@horof/shared';

/** «؟ مساعدة», screen by screen (doc 52): short steps, the buttons' words. */
export const HELP: HelpTopic[] = [
  {
    path: '/',
    title: 'المالية',
    steps: [
      'دخل مال إلى الصندوق؟ اضغط «مدخول».',
      'خرج مال؟ اضغط «مصروف» وصوّر الوصل.',
      'إيداع في البنك أو سحب منه: الزر الأزرق.',
      'آخر ما سجّلته يظهر أسفل الشاشة: اضغط عليه لتصحيحه.',
    ],
  },
  {
    path: '/new/:type',
    title: 'عملية جديدة',
    steps: [
      'اكتب المبلغ.',
      'اختر المشروع، واكتب البيان، مثلاً «فاتورة الكهرباء».',
      'صوّر الوصل أو الفاتورة.',
      'اضغط «حفظ».',
    ],
  },
  {
    path: '/bank',
    title: 'البنك',
    steps: [
      'اختر: إيداع أو سحب.',
      'اكتب المبلغ، وصوّر الوصل الذي أعطاك البنك.',
      'اضغط «حفظ».',
    ],
  },
  {
    path: '/operations/*',
    title: 'العمليات',
    steps: [
      'ابحث في البيان.',
      'افتح العملية لتصحيحها أو حذفها.',
      'ما جاء من البنك أو من الدفاتر القديمة يُصحَّح من الحاسوب.',
    ],
  },
];
